import React from 'react';

export default () =>
  <div className="full-vh grid grid--center-center">
    <h3>Sorry, page not found!</h3>
  </div>;
